// const APP_URL = "http://enorme-member.harrys:8000/app";
// const API_URL = "http://enorme-admin.harrys:8000/api";
const APP_URL = "https://loyalty.enormehotels.com/app";
const API_URL = "https://app.enormehotels.com/api";

const API_KEY = "e00cde49dd87024feda9f8dfe1022afc882bedca11d85c4dfb1c9e131b-6Z3diSyVmq0nljTi";

const APP_VERSION = '1.0.0';

const DEBUG_NOTIFICATIONS = true;

const HOTEL_TYPE = {
    HOTEL: 0,
    VILLA: 1,
}

const POINTS_ACTION = {
    ADD: 1,
    REMOVE: 2,
    TRANSFER: 3,
    SIGNUP: 4,
    CHECKIN: 5,
}


const PASSWORD_TIP = "Password must be at least 8 characters long and must contain latin letters, symbols or numbers.";

export {
    APP_URL,
    API_URL,
    API_KEY,
    APP_VERSION,
    HOTEL_TYPE,
    POINTS_ACTION,
    PASSWORD_TIP,
}